import type React from 'react';
import type { PropsWithChildren } from 'react';

import { useIsTopBarHidden } from '@xing-com/crate-hooks-use-is-top-bar-hidden';
import { Column, Row } from '@xing-com/xing-grid';

import { Styled } from './styles';

const PageHeaderSkeleton: React.FC = () => {
  const isTopBarHidden = useIsTopBarHidden();

  return isTopBarHidden ? (
    <Styled.SkeletonPageHeaderContainer>
      <Styled.SkeletonPageHeaderHeadline amountRows={1} />
    </Styled.SkeletonPageHeaderContainer>
  ) : (
    <Styled.SkeletonPageHeaderContainer>
      <Styled.SkeletonPageHeaderHeadline size="small" amountRows={1} />
    </Styled.SkeletonPageHeaderContainer>
  );
};

type SkeletonContainerProps = {
  noHeader?: boolean;
};

const SkeletonContainer: React.FC<
  PropsWithChildren<SkeletonContainerProps>
> = ({ children, noHeader }) => {
  return (
    <Styled.SkeletonContainer>
      {!noHeader ? (
        <Row>
          <Column size={12}>
            <PageHeaderSkeleton />
          </Column>
        </Row>
      ) : null}

      {children}
    </Styled.SkeletonContainer>
  );
};

export default SkeletonContainer;
